<template>
  <router-link 
    :to="to"
    :class="classList"
    class="Link">
    <font-awesome-icon :icon="['fas', 'angle-right']" /> {{ label }}
  </router-link>
</template>

<script>
export default {
  name: 'Link',
  props: {
    label: {
      type: String,
      required: true
    },
    to: {
      type: Object,
      required: true
    },
    arrow: {
      type: Boolean,
      default: false
    },
    alternate: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classList() {
      return {
        'Link--arrow' : this.arrow,
        'Link--alternate' : this.alternate,
        'Link--inline' : this.inline
      }
    }
  }
}
</script>

<style lang="scss">
  .Link {
    text-decoration: none;
    color: $color_primary;
    font-family: $font_nav;

    &:hover {
      color: $metro_oranje;
    }

    svg {
      display: none;
    }

    &--arrow {
      svg {
        display: initial;
      }
    }

    &--alternate {
      color: $antraciet_blauw;

      &:hover {
        color: $antraciet_blauw_medium;
      }
    }

    &--inline {
      display: inline !important;
    }
  }
</style>
